import { render, staticRenderFns } from "./show-point-dialog.vue?vue&type=template&id=fc4f8404&scoped=true"
import script from "./show-point-dialog.vue?vue&type=script&lang=js"
export * from "./show-point-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4f8404",
  null
  
)

export default component.exports